import React from 'react';
var FourOFour = function FourOFour() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h2", null, "ERROR 404"), /*#__PURE__*/React.createElement("h1", null, "Page Not Found"), /*#__PURE__*/React.createElement("p", null, "The page you're looking for doesn't exist."));
};
export default FourOFour;